/**
 * LandingPage.js - Enhanced with Federation & Trial Journey
 *
 * Swiss & High-Contrast theme with scroll-triggered entrance animations.
 * New: Enterprise Federation section, Trial Journey section, Live Demo CTAs.
 */

import {
  Navbar,
  HeroSection,
  TrustBarSection,
  PlatformInActionSection,
  TCOComparisonSection,
  ServiceAsSoftwareSection,
  SevenRsSection,
  FeaturesSection,
  BCMFrameworkSection,
  EnterpriseFederationSection,
  TrialJourneySection,
  CTASection,
  Footer,
} from "../components/landing";
import ScrollReveal from "../components/landing/ScrollReveal";

export default function LandingPage() {
  const handleGetStarted = () => {
    window.location.href = "/request-demo";
  };

  return (
    <div className="min-h-screen bg-zinc-50 overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <ScrollReveal>
        <HeroSection />
      </ScrollReveal>
      <ScrollReveal delay={0.1}>
        <TrustBarSection />
      </ScrollReveal>
      <ScrollReveal>
        <PlatformInActionSection />
      </ScrollReveal>
      <ScrollReveal>
        <TCOComparisonSection />
      </ScrollReveal>
      <ScrollReveal>
        <ServiceAsSoftwareSection onGetStarted={handleGetStarted} />
      </ScrollReveal>
      <ScrollReveal>
        <SevenRsSection />
      </ScrollReveal>
      <ScrollReveal>
        <FeaturesSection />
      </ScrollReveal>
      <ScrollReveal>
        <EnterpriseFederationSection />
      </ScrollReveal>
      <ScrollReveal>
        <BCMFrameworkSection />
      </ScrollReveal>
      <ScrollReveal>
        <TrialJourneySection />
      </ScrollReveal>
      <ScrollReveal>
        <CTASection />
      </ScrollReveal>
      <ScrollReveal>
        <Footer />
      </ScrollReveal>
    </div>
  );
}
